import { memo } from 'react';
import { Group, Rect } from 'react-konva';
import { resolveOht2DFoupColors } from './oht2dPalette';
import type { Foup2DProps } from './types';

/** Detachable FOUP — matches reference (rounded square + gloss marks). */
export const Foup2D = memo(function Foup2D({
  x = 0,
  y = 0,
  width,
  height,
  foupKind = 'raw',
  strokeWidth = 0.06,
  detailed = true,
  opacity = 1,
  listening = false,
}: Foup2DProps) {
  const r = Math.min(width, height) * 0.2;
  const colors = resolveOht2DFoupColors(foupKind);

  return (
    <Group x={x} y={y} opacity={opacity} listening={listening}>
      <Rect
        width={width}
        height={height}
        fill={colors.fill}
        cornerRadius={r}
        stroke={colors.stroke}
        strokeWidth={strokeWidth}
        perfectDrawEnabled={false}
        shadowForStrokeEnabled={false}
      />
      {detailed && (
        <>
          <Rect
            x={width * 0.12}
            y={height * 0.12}
            width={width * 0.76}
            height={height * 0.13}
            fill={colors.highlight}
            cornerRadius={height * 0.06}
            opacity={0.95}
            listening={false}
            perfectDrawEnabled={false}
          />
          <Rect
            x={width * 0.12}
            y={height * 0.72}
            width={width * 0.2}
            height={height * 0.11}
            fill={colors.highlight}
            cornerRadius={height * 0.08}
            opacity={0.85}
            listening={false}
            perfectDrawEnabled={false}
          />
        </>
      )}
    </Group>
  );
});
